export class MBAuthUtil {
  static getAuthToken(): string | null | undefined {
    return localStorage.getItem('authToken');
  }

  static getBizAuthToken(): string | null | undefined {
    return localStorage.getItem('authBizToken');
  }
}
